import { CentroLogisticoCementoDto } from '../../../models/centro-logistico-cemento.dto';
import { CentroLogisticoCemento } from '../../../models/centro-logistico-cemento.model';
import { CentroLogisticoCementoVm } from '../../../models/centro-logistico-cemento.vm';

function asText(value: unknown): string {
  if (typeof value === 'string') {
    return value.trim();
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value).trim();
  }
  return '';
}

function asPositiveInteger(value: unknown): number {
  const numericValue = Number(value);
  return Number.isInteger(numericValue) && numericValue > 0 ? numericValue : 0;
}

export class CentroLogisticoCementoMapper {
  static toDomain(dto: CentroLogisticoCementoDto): CentroLogisticoCemento {
    return {
      id: asPositiveInteger(dto.id),
      puestoExploracion: asText(dto.puestoExploracion),
      centro: asText(dto.centro),
      centroNombre: asText(dto.centroNombre),
      planta: asText(dto.planta),
    };
  }

  static toVm(dto: CentroLogisticoCementoDto): CentroLogisticoCementoVm {
    const item = CentroLogisticoCementoMapper.toDomain(dto);
    const baseKey = [item.puestoExploracion, item.centro, item.centroNombre].join('|');
    return {
      ...item,
      trackId: String(item.id || baseKey),
    };
  }

  static toVmList(dtos: CentroLogisticoCementoDto[]): CentroLogisticoCementoVm[] {
    return dtos.map((dto) => CentroLogisticoCementoMapper.toVm(dto));
  }
}
